import { Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserAccountsService } from '../../../common/user-accounts/user-accounts.service';
import { UserService } from '../../../core/services/user.service';
import { FormSupportService } from '../../../core/services/form-support.service';
import { HeadlessView } from '../../../common/shared/components/headless-view';
import { LayoutService } from '../../../common/layout/layout.service';
import { MobileDetectorService } from '../../../common/shared/mobile-detector.service';

@Component({
    selector: 'ns-password-change',
    templateUrl: './password-change.component.html',
    styleUrls: ['./password-change.component.scss']
})
export class PasswordChangeComponent extends HeadlessView implements OnInit, OnDestroy {

    public subscription: Subscription = new Subscription();

    public user: any;

    public form: FormGroup = this.formBuilder.group({
        newPassword: [null, Validators.required],
        oldPassword: [null, Validators.required]
    });

    constructor(
        protected layoutService: LayoutService,
        protected mobileDetectorService: MobileDetectorService,
        private formBuilder: FormBuilder,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private userAccountsService: UserAccountsService,
        private userService: UserService,
        private formSupport: FormSupportService
    ) {
        super(layoutService, mobileDetectorService);

        this.layoutService.enableFooter();
    }

    ngOnInit() {
        this.user = this.userService.user;
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.subscription.unsubscribe();
    }

    onSubmit() {
        this.formSupport.formSubmitHelper(
            this.form,
            this.userAccountsService.changePassword,
            [this.form.getRawValue()]
        ).then(offer => {
            this.router.navigate(['/']);
        }).catch(err => {
        });
    }

}
